import { useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Overlay } from 'react-bootstrap';
import { SecurityContext } from 'gossamer-unified';
import { CustomInfo } from 'cb-unified';
import classes from './AccountMenu.module.css';

interface AccountMenuProps {
  hasActiveTask?: boolean;
  unread?: boolean;
  user?: SecurityContext;
}

interface MenuItemProps {
  label: string;
  href: string;
  imgSrc?: string;
  additionalClass?: string;
}

export const AccountMenu = ({ unread = false, hasActiveTask = false, user }: AccountMenuProps) => {
  const [show, setShow] = useState(false);
  const adminOfInstitutionId = (user?.customInfo as CustomInfo)?.adminInstitutionId || undefined;
  const canUpgrade =
    !!user && user.roleId !== 'staff' && (user?.customInfo as CustomInfo)?.adminInstitutionType !== 'enterprise';
  const target = useRef<HTMLDivElement>(null);

  const MenuItem = (props: MenuItemProps) => {
    const { label, href, imgSrc, additionalClass } = props;
    const itemClasses = [classes.accountMenuItem];
    if (additionalClass) {
      itemClasses.push(additionalClass);
    }
    return (
      <NavLink to={href} className={itemClasses.join(' ')} onClick={() => setShow(false)}>
        {imgSrc && <img src={imgSrc} />}
        {label}
      </NavLink>
    );
  };

  return (
    <>
      <div ref={target} onClick={() => setShow(!show)} className={classes.avatarButton}>
        <img
          src={(user?.customInfo as CustomInfo)?.photo || '/assets/icons/user.svg'}
          alt={user?.name || 'User avatar'}
          className={classes.avatar}
        />
        {unread && <span className={classes.unreadMsgDot}>•</span>}
        {hasActiveTask && <span className={classes.activeTaskDot}>•</span>}
      </div>
      <Overlay target={target.current} show={show} placement="bottom" rootClose={true} onHide={() => setShow(false)}>
        <div className={classes.accountMenuPanel}>
          <div className={classes.userName}>
            {!!user?.roleId && user?.roleId !== 'user' && (
              <NavLink to={`/admin/user/display/${user?.userId}`}>{user?.name || ''}</NavLink>
            )}
            {!user?.roleId || (user?.roleId === 'user' && <span>{user?.name || ''}</span>)}
          </div>
          <MenuItem label="My Calendar" href="/website/account/calendar" imgSrc="/assets/icons/calendar.svg" />
          <MenuItem label="My Profile" href="/website/account/profile" imgSrc="/assets/icons/user.svg" />
          <MenuItem
            label="Inbox"
            href={`/website/inbox`}
            imgSrc="/assets/icons/envelope.svg"
            additionalClass={(unread && classes.unreadMsgDot) || undefined}
          />
          <MenuItem
            label="Tasks"
            href={`/website/tasks`}
            imgSrc="/assets/icons/bell-alert.svg"
            additionalClass={(hasActiveTask && classes.activeTaskDot) || undefined}
          />
          <MenuItem label="Hosting Events" href="/website/hosting" imgSrc="/assets/icons/ticket.svg" />
          {/* <MenuItem label="Video Guides" href="/website/video-guides" imgSrc="/assets/icons/light-bulb.svg" /> */}
          {canUpgrade && (
            <a href="/website/upgrade-plan" className={classes.accountMenuItem}>
              <img src="/assets/icons/rocket-launch.svg" />
              Upgrade my Plan
            </a>
          )}
          <MenuItem label="Contact Us" href="/website/contact-us" imgSrc="/assets/icons/phone.svg" />

          {adminOfInstitutionId && (
            <>
              <hr />
              <MenuItem
                label="Admin Dashboard"
                href={`/admin/institution/display/${adminOfInstitutionId}`}
                imgSrc="/assets/icons/settings.svg"
              />
            </>
          )}
          <hr />
          <MenuItem label="Logout" href="/auth/logout" imgSrc="/assets/icons/exit.svg" />
        </div>
      </Overlay>
    </>
  );
};
